export default __webpack_public_path__ + "static/media/controlContact24.d004740b.svg";